import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';
import { OrganizationsUIProvider } from './OrganizationsContextProvider';

const OrganizationsList = React.lazy(() => import('./Organizations'));

function Organizations(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>برگزارکنندگان</PageTitle>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <OrganizationsUIProvider>
          <OrganizationsList {...props} />
        </OrganizationsUIProvider>
      </Suspense>
    </Page>
  );
}

export default Organizations;
